var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 21.598c-.23 0-.459-.06-.658-.18-3.161-1.83-8.576-5.7-9.264-11.1-.289-2.3.25-4.33 1.516-5.7 1.047-1.13 2.493-1.69 4.078-1.61 1.765.1 3.24.93 4.268 2.4.02.03.04.05.06.08.02-.03.04-.05.06-.08 1.027-1.47 2.502-2.3 4.267-2.4 1.576-.08 3.032.48 4.079 1.61 1.276 1.37 1.814 3.39 1.515 5.7-.688 5.41-6.102 9.28-9.273 11.11-.21.12-.419.17-.648.17zM7.35 4.497c-1.037 0-1.984.4-2.672 1.14-.967 1.04-1.366 2.63-1.127 4.48.618 4.88 6.033 8.54 8.436 9.94 2.403-1.4 7.827-5.07 8.446-9.94.239-1.85-.16-3.45-1.127-4.48-.738-.79-1.775-1.2-2.902-1.13-1.306.07-2.363.67-3.13 1.77a4.4 4.4 0 00-.56 1.19.746.746 0 01-1.445 0s-.17-.64-.559-1.19c-.767-1.1-1.824-1.69-3.13-1.77h-.24l.01-.01z",
    fill: "currentColor"
  })));
}
export default SvgHeart;